/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import React from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import forwardRefWithStatics from '../_util/forwardRefWithStatics.js';
import { MenuContext } from './MenuContext.js';
import { DEFAULT_MENU_WIDTH } from './_util/constant.js';
import useMenuContext from './hooks/useMenuContext.js';
import { menuDefaultProps } from './defaultProps.js';
import HeadMenu from './HeadMenu.js';
import SubMenu from './SubMenu.js';
import MenuItem from './MenuItem.js';
import MenuGroup from './MenuGroup.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import 'hoist-non-react-statics';
import '../_util/noop.js';
import '../_chunks/dep-f41383e1.js';
import '../_chunks/dep-f66447d3.js';
import '../_chunks/dep-605e961c.js';
import './_util/checkSubMenuChildExpanded.js';
import './_util/type.js';
import '../tabs/index.js';
import '../tabs/Tabs.js';
import '../tabs/TabNav.js';
import 'tdesign-icons-react';
import '../_chunks/dep-ac257584.js';
import '../_chunks/dep-37e82645.js';
import '../_chunks/dep-a0293295.js';
import '../tabs/useTabClass.js';
import '../tabs/TabNavItem.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import '../hooks/useDomRefCallback.js';
import '../hooks/useGlobalIcon.js';
import '../tabs/TabBar.js';
import '../_util/useMutationObserver.js';
import '../_common/js/tabs/base.js';
import '../tabs/TabPanel.js';
import '../tabs/defaultProps.js';
import '../_util/useDragSorter.js';
import '../tabs/style/css.js';
import '../tabs/type.js';
import './_util/checkSubMenuActive.js';
import './_util/checkMenuType.js';
import './_util/checkSubMenuChildrenActive.js';
import './_util/getSubMenuChildStyle.js';
import '../common/FakeArrow.js';
import './_util/cacularPaddingLeft.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Menu = forwardRefWithStatics(function (props, ref) {
  var _classNames;
  var className = props.className,
    _props$width = props.width,
    width = _props$width === void 0 ? DEFAULT_MENU_WIDTH : _props$width,
    children = props.children,
    theme = props.theme,
    logo = props.logo,
    operations = props.operations,
    style = props.style;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useMenuContext = useMenuContext(_objectSpread(_objectSpread({}, props), {}, {
      children: children,
      mode: "accordion"
    })),
    value = _useMenuContext.value;
  var menuWidthArr = Array.isArray(width) ? width : [width, DEFAULT_MENU_WIDTH[1]];
  var collapsed = value.collapsed;
  return /* @__PURE__ */React.createElement(MenuContext.Provider, {
    value: value
  }, /* @__PURE__ */React.createElement("div", {
    ref: ref,
    className: classNames("".concat(classPrefix, "-default-menu"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-is-collapsed"), collapsed), _defineProperty(_classNames, "".concat(classPrefix, "-menu--dark"), theme === "dark"), _classNames)),
    style: _objectSpread({
      width: collapsed ? menuWidthArr[1] : menuWidthArr[0]
    }, style)
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-default-menu__inner")
  }, logo && /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-menu__logo")
  }, logo), /* @__PURE__ */React.createElement("ul", {
    className: classNames("".concat(classPrefix, "-menu"), _defineProperty({}, "".concat(classPrefix, "-menu--scroll"), !collapsed))
  }, children), operations && /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-menu__operations")
  }, operations))));
}, {
  HeadMenu: HeadMenu,
  SubMenu: SubMenu,
  MenuItem: MenuItem,
  MenuGroup: MenuGroup
});
Menu.displayName = "Menu";
Menu.defaultProps = menuDefaultProps;

export { Menu as default };
//# sourceMappingURL=Menu.js.map
